<ng-container *ngIf="viewModel$ | async as vm">
  <dk-dx-data-table2
    keyExpr="Kod"
    [tableTittle]="'Form İşlem Logları'"
    [height]="'70vh'"
    [dataSource]="dataSource"
    [columnList]="vm.columnList"
    [gridCtlList]="vm.gridCtl"
    [columnTransactions]="false"
    [dontSelectDataSource]="true"
    [showBorders]="true"
  >
  </dk-dx-data-table2>
</ng-container>
